const API_URL = process.env.REACT_APP_API_URL;

// ── Subject by ID ─────────────────────────────────────────────────────────────

export const fetchSubjectById2 = async (subjectId) => {
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

// ── Module by ID ──────────────────────────────────────────────────────────────

export const fetchModuleById = async (moduleId) => {
  const res = await fetch(`${API_URL}/api/note-modules/${moduleId}`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

// ── Modules (subject-centric) ─────────────────────────────────────────────────

export const fetchModulesBySubject = async (subjectId) => {
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}/modules`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const createModuleForSubject = async (subjectId, title) => {
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}/modules`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const updateModuleById = async (subjectId, moduleId, title) => {
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}/modules/${moduleId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const deleteModuleById = async (subjectId, moduleId) => {
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}/modules/${moduleId}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Topics (module-centric) ───────────────────────────────────────────────────

export const fetchTopicsByModule = async (moduleId) => {
  const res = await fetch(`${API_URL}/api/note-modules/${moduleId}/topics`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const createTopicForModule = async (moduleId, title, readingDuration = 0) => {
  const res = await fetch(`${API_URL}/api/note-modules/${moduleId}/topics`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, readingDuration: Number(readingDuration) || 0 }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const updateTopicById = async (moduleId, topicId, title, readingDuration = 0) => {
  const res = await fetch(`${API_URL}/api/note-modules/${moduleId}/topics/${topicId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, readingDuration: Number(readingDuration) || 0 }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const deleteTopicById = async (moduleId, topicId) => {
  const res = await fetch(`${API_URL}/api/note-modules/${moduleId}/topics/${topicId}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Subjects (global list with stats) ────────────────────────────────────────

export const updateSubjectById = async (subjectId, title) => {
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const createSubjectGlobally = async (title) => {
  const res = await fetch(`${API_URL}/api/note-subjects`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const fetchAllSubjectsWithStats = async ({ page = 1, pageSize = 20, search = "" } = {}) => {
  const params = new URLSearchParams({ page, pageSize });
  if (search.trim()) params.append("search", search.trim());
  const res = await fetch(`${API_URL}/api/note-subjects?${params}`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Subjects ─────────────────────────────────────────────────────────────────

export const fetchSubjects = async (courseId) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const createSubject = async (courseId, title) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const updateSubject = async (courseId, subjectId, title) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects/${subjectId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const deleteSubject = async (courseId, subjectId) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects/${subjectId}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Modules ───────────────────────────────────────────────────────────────────

export const fetchModules = async (courseId, subjectId) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const createModule = async (courseId, subjectId, title) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const updateModule = async (courseId, subjectId, moduleId, title) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules/${moduleId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const deleteModule = async (courseId, subjectId, moduleId) => {
  const res = await fetch(`${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules/${moduleId}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Topics ────────────────────────────────────────────────────────────────────

export const fetchTopics = async (courseId, subjectId, moduleId) => {
  const res = await fetch(
    `${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules/${moduleId}/topics`
  );
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const fetchTopicById = async (topicId) => {
  const res = await fetch(`${API_URL}/api/note-topics/${topicId}`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const createTopic = async (courseId, subjectId, moduleId, title) => {
  const res = await fetch(
    `${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules/${moduleId}/topics`,
    { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ title }) }
  );
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const updateTopic = async (courseId, subjectId, moduleId, topicId, title) => {
  const res = await fetch(
    `${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules/${moduleId}/topics/${topicId}`,
    { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ title }) }
  );
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const deleteTopic = async (courseId, subjectId, moduleId, topicId) => {
  const res = await fetch(
    `${API_URL}/api/courses/${courseId}/subjects/${subjectId}/modules/${moduleId}/topics/${topicId}`,
    { method: "DELETE" }
  );
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Sections ──────────────────────────────────────────────────────────────────

export const fetchSections = async (topicId) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/sections`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const fetchSectionById = async (sectionId) => {
  const res = await fetch(`${API_URL}/api/sections/${sectionId}`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const createSection = async (topicId, { title, type }) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/sections`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, type }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const updateSection = async (sectionId, { title }) => {
  const res = await fetch(`${API_URL}/api/sections/${sectionId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const deleteSection = async (sectionId) => {
  const res = await fetch(`${API_URL}/api/sections/${sectionId}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Reorder ───────────────────────────────────────────────────────────────────

export const reorderModules = async (subjectId, orderedIds) => {
  const res = await fetch(`${API_URL}/api/note-subjects/${subjectId}/modules/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderedIds }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const reorderTopics = async (moduleId, orderedIds) => {
  const res = await fetch(`${API_URL}/api/note-modules/${moduleId}/topics/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderedIds }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const reorderSections = async (topicId, orderedIds) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/sections/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderedIds }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Section Content ───────────────────────────────────────────────────────────

export const updateSectionNotesText = async (sectionId, notesText) => {
  const res = await fetch(`${API_URL}/api/sections/${sectionId}/notes-text`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ notesText }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const addQuestionToSection = async (sectionId, questionId) => {
  const res = await fetch(`${API_URL}/api/sections/${sectionId}/questions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ questionId }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const removeQuestionFromSection = async (sectionId, questionId) => {
  const res = await fetch(`${API_URL}/api/sections/${sectionId}/questions/${questionId}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Notes ─────────────────────────────────────────────────────────────────────

export const fetchNotes = async (topicId) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/notes`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const fetchNoteById = async (topicId, noteId) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/notes/${noteId}`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const createNote = async (topicId, { title, notesText }) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/notes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, notesText }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const updateNote = async (topicId, noteId, { title, notesText }) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/notes/${noteId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, notesText }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const deleteNote = async (topicId, noteId) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/notes/${noteId}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const attachQuestionToNote = async (topicId, noteId, questionId) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/notes/${noteId}/questions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ questionId }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const detachQuestionFromNote = async (topicId, noteId, questionId) => {
  const res = await fetch(
    `${API_URL}/api/topics/${topicId}/notes/${noteId}/questions/${questionId}`,
    { method: "DELETE" }
  );
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

// ── Question Sets ─────────────────────────────────────────────────────────────

export const fetchQuestionSet = async (topicId, type) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/question-sets/${type}`);
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return (await res.json()).data;
};

export const addQuestionToSet = async (topicId, type, questionId) => {
  const res = await fetch(`${API_URL}/api/topics/${topicId}/question-sets/${type}/questions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ questionId }),
  });
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};

export const removeQuestionFromSet = async (topicId, type, questionId) => {
  const res = await fetch(
    `${API_URL}/api/topics/${topicId}/question-sets/${type}/questions/${questionId}`,
    { method: "DELETE" }
  );
  if (!res.ok) throw new Error(`HTTP error ${res.status}`);
  return res.json();
};
